import gql from "graphql-tag";
import { invoiceDetailsFields } from "../queries/getInvoice";

export const CREATE_INVOICE = gql`mutation createInvoice($createInvoiceInput: CreateInvoiceInput!) {
    createInvoice(createInvoiceInput: $createInvoiceInput) {
        ${invoiceDetailsFields}
    }
}`;
